export const UTM_PARAMS_KEY = 'UTM_PARAMS';
